import { render, staticRenderFns } from "./DriverFile.vue?vue&type=template&id=51edb230&scoped=true&"
import script from "./DriverFile.vue?vue&type=script&lang=js&"
export * from "./DriverFile.vue?vue&type=script&lang=js&"
import style0 from "./DriverFile.vue?vue&type=style&index=0&id=51edb230&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51edb230",
  null
  
)

export default component.exports